import { ParamEventIdOrLatest, ParamIssueShortId, ParamIssueUrl, ParamOrganizationSlug, ParamRegionUrl } from "./schema-DKEjeVqP.js";
import { ApiNotFoundError } from "./errors-DG2FreDU.js";
import { defineTool } from "./define-SD6AQa4b.js";
import { apiServiceFromContext } from "./api-EaEPyKlQ.js";
import { enhanceNotFoundError } from "./enhance-error-BDXGhe5E.js";
import { parseIssueParams } from "./issue-helpers-0Dnme3Ym.js";
import { ensureIssueWithinProjectConstraint } from "./issue-D65xI0F7.js";
import { fetchAndFormatBreadcrumbs } from "./breadcrumbs-BltIlpas.js";
import { setTag } from "@sentry/core";

//#region src/tools/catalog/get-issue-breadcrumbs.ts
var get_issue_breadcrumbs_default = defineTool({
	name: "get_issue_breadcrumbs",
	skills: ["inspect", "triage"],
	requiredScopes: ["event:read"],
	description: [
		"Get the breadcrumb trail from a Sentry issue event.",
		"Defaults to the latest event when eventId is omitted.",
		"",
		"Use this tool when you need to:",
		"- See the user and application actions leading up to an error",
		"- Inspect navigation, console, HTTP, and other breadcrumb events",
		"- Reconstruct the immediate context before an issue occurred",
		"- Compare breadcrumb trails across multiple events in the same issue",
		"",
		"<examples>",
		"get_issue_breadcrumbs(organizationSlug='my-org', issueId='PROJECT-123')",
		"get_issue_breadcrumbs(organizationSlug='my-org', issueId='PROJECT-123', eventId='c49541c747cb4d8aa3efb70ca5aba243')",
		"get_issue_breadcrumbs(issueUrl='https://my-org.sentry.io/issues/PROJECT-123/')",
		"</examples>"
	].join("\n"),
	inputSchema: {
		organizationSlug: ParamOrganizationSlug.optional(),
		regionUrl: ParamRegionUrl.nullable().default(null),
		issueId: ParamIssueShortId.optional(),
		issueUrl: ParamIssueUrl.optional(),
		eventId: ParamEventIdOrLatest
	},
	annotations: {
		readOnlyHint: true,
		destructiveHint: false,
		openWorldHint: true
	},
	async handler(params, context) {
		const parsed = parseIssueParams({
			issueUrl: params.issueUrl,
			issueId: params.issueId,
			organizationSlug: params.organizationSlug ?? context.constraints.organizationSlug
		});
		const apiService = apiServiceFromContext(context, { regionUrl: params.regionUrl ?? context.constraints.regionUrl ?? void 0 });
		setTag("organization.slug", parsed.organizationSlug);
		setTag("issue.id", parsed.issueId);
		try {
			await ensureIssueWithinProjectConstraint({
				apiService,
				organizationSlug: parsed.organizationSlug,
				issueId: parsed.issueId,
				projectSlug: context.constraints.projectSlug
			});
			return await fetchAndFormatBreadcrumbs(apiService, parsed.organizationSlug, parsed.issueId, params.eventId);
		} catch (error) {
			if (error instanceof ApiNotFoundError) throw enhanceNotFoundError(error, {
				organizationSlug: parsed.organizationSlug,
				issueId: parsed.issueId,
				eventId: params.eventId
			});
			throw error;
		}
	}
});

//#endregion
export { get_issue_breadcrumbs_default };
//# sourceMappingURL=get-issue-breadcrumbs-D5AeF8Vm.js.map